import React, {Component} from 'react';
import {Row, Col, Button, Input} from 'reactstrap';

import SyntaxHighlighter from 'react-syntax-highlighter/prism';
import { prism } from 'react-syntax-highlighter/styles/prism';
import MarkdownRender from "../../MarkdownRendererComponent";

import TestCaseList from './TestCaseListComponent'

import _ from 'lodash'

class CodeReview extends Component
{
	constructor(props)
	{
		super(props);


		this.state=
			{
				idSubmission:null,
				codeReview:
				{
					general:'',
					comments:[]
				}
				
			}

		this.getLineStyle = this.getLineStyle.bind(this);
		this.onGeneralCommentChange = this.onGeneralCommentChange.bind(this);
		this.onAddButtonClicked = this.onAddButtonClicked.bind(this);
		this._onSetCodeReview = this._onSetCodeReview.bind(this);

	}

	static getDerivedStateFromProps(props, state)
	{
		if(props.submission.idProblemSubmission !== state.idSubmission)
		{
			if(props.submission.anwsered)
			{
				return {
					idSubmission: props.submission.idProblemSubmission,
					codeReview:props.submission.codeReview
				}
			}
			else
			{
				return {
					idSubmission:props.submission.idProblemSubmission
				}
			}
		}
	}

	
	getLineStyle(lineNumber)
	{
		
		if(_.some(this.state.codeReview.comments, (el)=>
			{
				return isLineInRange(lineNumber, el.lines);
			}))
		{
			return { style: {display: 'block', 'background-color': 'rgba(255, 153, 0, 0.32)' }}
		}


		return {};
	}

	onGeneralCommentChange(event)
	{
		this.props.onSetCodeReviewModalDirty(true);
		const value = event.target.value;
		this.setState((prevState)=>
			(
				{
					codeReview:
					{
						general:value,
						comments:prevState.codeReview.comments
					}
				}
			));
	}

	onLineChange(index, value)
	{
		var regex = /^(\d+(-\d*)?)?$/;

		if(value.match(regex) !== null)
		{
			this.props.onSetCodeReviewModalDirty(true);
			this.setState((prevState)=>
				{
					var lineComment = prevState.codeReview.comments[index].comment;
					var pre = prevState.codeReview.comments.slice(0, index);
					var post = prevState.codeReview.comments.slice(index+1);
					var obj = {lines:value, comment:lineComment};

					return {
						codeReview:
						{
							general:prevState.codeReview.general,
							comments:pre.concat([obj], post)
						}
					}
				});
		}
	}

	onLineCommentChange(index, value)
	{
		this.props.onSetCodeReviewModalDirty(true);
		this.setState((prevState)=>
			{
				var key = prevState.codeReview.comments[index].lines;
				var pre = prevState.codeReview.comments.slice(0, index);
				var post = prevState.codeReview.comments.slice(index+1);
				var obj = {lines:key, comment:value};

				return {
					codeReview:
					{
						general:prevState.codeReview.general,
						comments:pre.concat([obj], post)
					}
				}
			});
	}

	onAddButtonClicked()
	{
		this.props.onSetCodeReviewModalDirty(true);
		this.setState((prevState)=>
			{
				var tmp = prevState.codeReview.comments.slice();
				tmp.push({lines:'',comment:''});

				return {
					codeReview:
					{
						general:prevState.codeReview.general,
						comments:tmp
					}
				}
			});
	}

	onRemoveButtonClicked(index)
	{
		this.props.onSetCodeReviewModalDirty(true);
		this.setState((prevState)=>
			{
				var pre = prevState.codeReview.comments.slice(0, index);
				var post = prevState.codeReview.comments.slice(index+1);

				return {
					codeReview:
					{
						general:prevState.codeReview.general,
						comments:pre.concat(post)
					}
				}
			});
	}

	_onSetCodeReview()
	{
		const allLinesOk = _.every(this.state.codeReview.comments, (el)=>
			{
				return isLinesValid(el.lines).valid;
			});

		const allCommentsOk = _.every(this.state.codeReview.comments, (el)=>
			{
				return el.comment.trim().length !== 0;
			});

		const generalCommentOk = this.state.codeReview.general.trim().length !== 0;

		if(!allLinesOk || !allCommentsOk || !generalCommentOk)
		{
			return ;
		}

		this.props.onSetCodeReview(this.props.submission.idProblemSubmission,
			this.state.codeReview);	
		this.props.onSetCodeReviewModalDirty(false, ()=>{this.props.toggle(true)});
		//this.props.toggle(true);
	}

	render()
	{
		const lineComments = this.state.codeReview.comments.map((el, indx)=>
			{
				return <LineComment lines={el.lines} comment={el.comment}
							onLineChange={(event)=>this.onLineChange(indx, event.target.value)}
							onLineCommentChange={(event)=>
									this.onLineCommentChange(indx, event.target.value)}
							onRemoveButtonClicked={()=>this.onRemoveButtonClicked(indx)}
						/>
			});

		const generalCommentOk = this.state.codeReview.general.trim().length !== 0;
		const generalCommentMessage = 'Komentar ne može da bude prazan';

		return (
			<React.Fragment>
				<Row>
					<Col xs='6'>
					   <SyntaxHighlighter
							language='c'
							style={prism}
							showLineNumbers={true}
							customStyle={{maxHeight:'80vh'}}
							wrapLines={true}
							lineProps={this.getLineStyle}
						>

							{this.props.submission.sourceFile}

						</SyntaxHighlighter>
					</Col>

					<Col xs='6' style={{overflow:'auto', maxHeight:'80vh'}}>
						<Row>
							<Col>Komentar</Col>
						</Row>
						<Row>
							<Col>
								<Input type='textarea' value = {this.state.codeReview.general}
									onChange={this.onGeneralCommentChange}
									className={generalCommentOk ? 'is-valid' : 'is-invalid'}
								/>
								{
									!generalCommentOk &&
									<span style={{color:'red'}}> {generalCommentMessage} </span>
								}
							</Col>
						</Row>

						<Row>
							<Col>Komentari za linije</Col>
						</Row>
						{lineComments}
						
						<Row className='justify-content-end'>
							<Col xs='auto'>
								<Button onClick={this.onAddButtonClicked}>+</Button>
							</Col>
						</Row>
						<Row className='mt-2'>
							<Col>
								<Button color='secondary' 
									onClick={this._onSetCodeReview}
									block={true}
								>
									Postavi komentar
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>

				<hr/>
				<Row>
					<Col>
						<h3>Tekst zadatka</h3>
					</Col>
				</Row>
				<Row >
					<Col>
						<div className='problemText p-3' id='problem'>
							<MarkdownRender source={this.props.submission.text}
										   escapeHtml={false}
							/>
						</div>


					</Col>
				</Row>
				<hr/>
				<Row>
					<Col>
						<TestCaseList graderOutput={this.props.submission.graderOutput}/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}

//=====================================Helper Component============================================
//
function isLinesValid(lines)
{
	if(typeof(lines) === 'number')
	{
		lines = lines.toString();
	}
	const match =  lines.match(/^(\d+|((\d+)-(\d+)))$/);

	if(match !== null)
	{
		if(match[3] !== undefined && match[4] !== undefined)
		{
			if(parseInt(match[3], 10) < parseInt(match[4], 10))
			{
				return {valid:true};
			}
			else
			{
				return {valid:false, message:'Prva linija mora da bude ispred druge'};
			}
		}
		else
		{
			return {valid:true};
		}
		
	}
	else
	{
		return {valid:false, message:'Fromat linije mora da bude: broj ili broj-broj'};
	}
}

function LineComment(props)
{
	const validLine = isLinesValid(props.lines);
	const validComment = props.comment.trim().length !== 0;

	const commentMessage = 'Komentar ne moze da bude prazan';

	return (
		<React.Fragment>
			<Row className='mb-1 align-items-center'>
				<Col xs='2'>
					<Row>
						<Col xs='auto'>Linije</Col>
					</Row>

					<Row>
						<Col>
							<Input type='text' value={props.lines}
								onChange={props.onLineChange}
								className={validLine.valid ? 'is-valid' : 'is-invalid'}
							/>
						</Col>
					</Row>
				</Col>

				<Col>
					<Row>
						<Col xs='auto'>Komentar</Col>
					</Row>

					<Row>
						<Col>
							<Input type='textarea' value={props.comment}
								onChange={props.onLineCommentChange}
								className={validComment ? 'is-valid' : 'is-invalid'}/>
						</Col>
					</Row>
				</Col>

				<Col xs='auto'>
					<Button onClick={props.onRemoveButtonClicked}>-</Button>
				</Col>
			</Row>

			{
				!validLine.valid &&
				<Row>
					<Col>
						<span style={{color:'red'}}>{validLine.message}</span>
					</Col>
				</Row>

			}

			{
				!validComment &&
				<Row>
					<Col>
						<span style={{color:'red'}}>{commentMessage}</span>
					</Col>
				</Row>
			}
		</React.Fragment>
	
	);
}

function isLineInRange(line, lineRange)
{
	if(typeof(lineRange) === 'number')
	{
		lineRange= lineRange.toString();
	}
	const match =  lineRange.match(/^(\d+|((\d+)-(\d+)))$/);

	if(match !== null)
	{
		var z = parseInt(line, 10);
		if(match[3] !== undefined && match[4] !== undefined)
		{
			var x = parseInt(match[3], 10);
			var y = parseInt(match[4], 10);
			if(x < y)
			{
				return z >= x && z <= y;
			}
			else
			{
				return false
			}
		}
		else
		{
			return z === parseInt(match[1], 10);
		}
	}
	else
	{
		return false;
	}
}

export default CodeReview;
